webpackJsonp([213534597649335,118785002076118],{

/***/ 241:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(242);
	
	var _Heading = __webpack_require__(43);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEGACY_ITEMS = [{
	  id: 1,
	  icon: "/assets/flag.png",
	  title: "Made In India",
	  description: "Authentic spices, born in India"
	}, {
	  id: 2,
	  icon: "/assets/heritage-spice.png",
	  title: "Heritage Spice Blends",
	  description: "Traditional recipes, perfected over time"
	}, {
	  id: 3,
	  icon: "/assets/love-across.png",
	  title: "Loved Across Generations",
	  description: "Trusted flavors, time after time"
	}, {
	  id: 4,
	  icon: "/assets/delicious-flavours.png",
	  title: "Delicious Flavours",
	  description: "Big on taste. Bold in aroma"
	}];
	
	var LegacyOfTaste = function LegacyOfTaste() {
	  return _react2.default.createElement(
	    "div",
	    { className: "legacy-of-taste" },
	    _react2.default.createElement(
	      "div",
	      { className: "legacy-of-taste__container" },
	      _react2.default.createElement(_Heading2.default, { title: "Our Legacy of Taste" }),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "div",
	        { className: "legacy-of-taste__grid" },
	        LEGACY_ITEMS.map(function (item) {
	          return _react2.default.createElement(
	            "div",
	            { key: item.id, className: "legacy-item" },
	            _react2.default.createElement(
	              "div",
	              { className: "legacy-item__icon" },
	              _react2.default.createElement("img", {
	                src: item.icon,
	                alt: item.title,
	                loading: "lazy",
	                onError: function onError(e) {
	                  e.target.style.display = "none";
	                }
	              })
	            ),
	            _react2.default.createElement(
	              "h3",
	              { className: "legacy-item__title" },
	              item.title
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "legacy-item__description" },
	              item.description
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = LegacyOfTaste;
	module.exports = exports["default"];

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _LegacyOfTaste = __webpack_require__(196);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LegacyOfTaste).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarqueeText = function MarqueeText() {
	  var slogans = ["Crafting bold Indian flavours since 1952", "Trusted by chefs and dealers nationwide", "Spices that taste like home", "Bulk and dealer enquiries welcome"];
	
	  return _react2.default.createElement(
	    "div",
	    { className: "marquee-container" },
	    _react2.default.createElement(
	      "div",
	      { className: "marquee" },
	      _react2.default.createElement(
	        "div",
	        { className: "marquee-content" },
	        slogans.map(function (slogan, index) {
	          return _react2.default.createElement(
	            "span",
	            { key: index, className: "marquee-item" },
	            slogan
	          );
	        }),
	        slogans.map(function (slogan, index) {
	          return _react2.default.createElement(
	            "span",
	            { key: "repeat-" + index, className: "marquee-item" },
	            slogan
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = MarqueeText;
	module.exports = exports["default"];

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductCard = function ProductCard(_ref) {
	  var item = _ref.item,
	      isHighlighted = _ref.isHighlighted;
	
	  var productUrl = "/products/Detail?" + item.type + "&" + (item.urlName.replace(/ /g, "-") || item.productName.replace(/ /g, "-"));
	
	  return _react2.default.createElement(
	    "div",
	    { className: "card-wrapper " + (isHighlighted ? "card-wrapper--highlighted" : "") },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: productUrl, className: "product-card" },
	      _react2.default.createElement(
	        "div",
	        { className: "product-card__container " + (isHighlighted ? "product-card__container--highlighted" : "") },
	        _react2.default.createElement(
	          "div",
	          { className: "product-card__image-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "product-card__image" },
	            _react2.default.createElement("img", {
	              src: item.imgUrl || item.imgUrls[0],
	              alt: item.productName,
	              loading: "lazy",
	              onError: function onError(e) {
	                e.target.onerror = null;
	                e.target.src = "/fallback-product-image.jpg"; // Add a fallback image path
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "product-card__content" },
	          _react2.default.createElement(
	            "h3",
	            { className: "product-card__title", title: item.productName },
	            item.productName
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "product-card__overlay" },
	          _react2.default.createElement(
	            "span",
	            { className: "product-card__cta" },
	            "View Details"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProductCard;
	module.exports = exports["default"];

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(62);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _ProductCard = __webpack_require__(102);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	var _productListConstant = __webpack_require__(42);
	
	__webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductCardsContainer = function (_React$Component) {
	  _inherits(ProductCardsContainer, _React$Component);
	
	  function ProductCardsContainer(props) {
	    _classCallCheck(this, ProductCardsContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.setSliderRef = function (ref) {
	      _this.slider = ref;
	    };
	
	    _this.handleResize = function () {
	      _this.setState({ windowWidth: window.innerWidth });
	    };
	
	    _this.afterChangeHandler = function (current) {
	      _this.setState({ currentSlide: current });
	    };
	
	    _this.state = {
	      currentSlide: 0,
	      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1200
	    };
	    _this.slider = null;
	    return _this;
	  }
	
	  ProductCardsContainer.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener("resize", this.handleResize);
	    this.handleResize();
	  };
	
	  ProductCardsContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.handleResize);
	  };
	
	  ProductCardsContainer.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$maxItems = this.props.maxItems,
	        maxItems = _props$maxItems === undefined ? 24 : _props$maxItems;
	    var _state = this.state,
	        currentSlide = _state.currentSlide,
	        windowWidth = _state.windowWidth;
	
	    var conveyor = [].concat(_productListConstant.SpiceDetails, _productListConstant.DhoopDetails);
	    var featuredProducts = conveyor.slice(0, maxItems);
	
	    var slidesToShow = 4;
	    if (windowWidth <= 1200) slidesToShow = 3;
	    if (windowWidth <= 992) slidesToShow = 2;
	    if (windowWidth <= 768) slidesToShow = 1;
	
	    var getHighlightedIndices = function getHighlightedIndices() {
	      if (slidesToShow >= 4) {
	        var firstCenter = (currentSlide + 1) % featuredProducts.length;
	        var secondCenter = (currentSlide + 2) % featuredProducts.length;
	        return [firstCenter, secondCenter];
	      } else if (slidesToShow === 3) {
	        var center = (currentSlide + 1) % featuredProducts.length;
	        return [center];
	      } else if (slidesToShow === 2) {
	        var firstCard = currentSlide % featuredProducts.length;
	        var secondCard = (currentSlide + 1) % featuredProducts.length;
	        return [firstCard, secondCard];
	      } else {
	        return [currentSlide];
	      }
	    };
	
	    var highlightedIndices = getHighlightedIndices();
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 500,
	      arrows: true,
	      autoplay: false,
	      slidesToShow: slidesToShow,
	      slidesToScroll: 1,
	      centerMode: false,
	      centerPadding: "0px",
	      className: "product-slider",
	      initialSlide: 0,
	      afterChange: this.afterChangeHandler,
	      responsive: [{
	        breakpoint: 1400,
	        settings: {
	          slidesToShow: 4,
	          slidesToScroll: 1,
	          centerPadding: "0px"
	        }
	      }, {
	        breakpoint: 1200,
	        settings: {
	          slidesToShow: 3,
	          slidesToScroll: 1,
	          centerPadding: "0px"
	        }
	      }, {
	        breakpoint: 992,
	        settings: {
	          slidesToShow: 3,
	          slidesToScroll: 1,
	          centerPadding: "0px"
	        }
	      }, {
	        breakpoint: 768,
	        settings: {
	          slidesToShow: 3,
	          slidesToScroll: 1,
	          centerPadding: "0px",
	          arrows: false
	        }
	      }, {
	        breakpoint: 576,
	        settings: {
	          slidesToShow: 2,
	          slidesToScroll: 1,
	          centerPadding: "0px",
	          arrows: false
	        }
	      }, {
	        breakpoint: 480,
	        settings: {
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          centerPadding: "0px",
	          arrows: false
	        }
	      }]
	    };
	
	    return _react2.default.createElement(
	      "div",
	      { className: "products-cards-container", style: { padding: "30px 80px 60px", position: "relative" } },
	      _react2.default.createElement(
	        "div",
	        { className: "products-cards-wrapper", style: { position: "relative" } },
	        _react2.default.createElement(
	          "button",
	          {
	            onClick: function onClick() {
	              return _this2.slider.slickPrev();
	            },
	            "aria-label": "Previous slide",
	            style: {
	              position: "absolute",
	              left: "-60px",
	              top: "50%",
	              transform: "translateY(-50%)",
	              zIndex: 1000,
	              width: "50px",
	              height: "50px",
	              border: "2px solid #ed3837",
	              borderRadius: "50%",
	              background: "white",
	              color: "#ed3837",
	              cursor: "pointer",
	              display: "flex",
	              alignItems: "center",
	              justifyContent: "center",
	              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
	              outline: "none"
	            },
	            onMouseEnter: function onMouseEnter(e) {
	              e.target.style.background = "#ed3837";
	              e.target.style.color = "white";
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              e.target.style.background = "white";
	              e.target.style.color = "#ed3837";
	            }
	          },
	          _react2.default.createElement(
	            "svg",
	            { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
	            _react2.default.createElement("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
	          )
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            onClick: function onClick() {
	              return _this2.slider.slickNext();
	            },
	            "aria-label": "Next slide",
	            style: {
	              position: "absolute",
	              right: "-60px",
	              top: "50%",
	              transform: "translateY(-50%)",
	              zIndex: 1000,
	              width: "50px",
	              height: "50px",
	              border: "2px solid #ed3837",
	              borderRadius: "50%",
	              background: "white",
	              color: "#ed3837",
	              cursor: "pointer",
	              display: "flex",
	              alignItems: "center",
	              justifyContent: "center",
	              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
	              outline: "none"
	            },
	            onMouseEnter: function onMouseEnter(e) {
	              e.target.style.background = "#ed3837";
	              e.target.style.color = "white";
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              e.target.style.background = "white";
	              e.target.style.color = "#ed3837";
	            }
	          },
	          _react2.default.createElement(
	            "svg",
	            { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
	            _react2.default.createElement("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
	          )
	        ),
	        _react2.default.createElement(
	          _reactSlick2.default,
	          _extends({ ref: this.setSliderRef }, settings),
	          featuredProducts.map(function (item, index) {
	            var isHighlighted = highlightedIndices.includes(index);
	
	            return _react2.default.createElement(
	              "div",
	              { key: item.productName, className: "slide-item " + (isHighlighted ? "slide-item--highlighted" : "") },
	              _react2.default.createElement(_ProductCard2.default, { item: item, isHighlighted: isHighlighted })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return ProductCardsContainer;
	}(_react2.default.Component);
	
	exports.default = ProductCardsContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ProductCardsContainer = __webpack_require__(201);
	
	Object.defineProperty(exports, "ProductCardsContainer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProductCardsContainer).default;
	  }
	});
	
	var _ProductCard = __webpack_require__(102);
	
	Object.defineProperty(exports, "ProductCard", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProductCard).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideItem = function SlideItem(_ref) {
	  var item = _ref.item;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/products/Detail?" + item.type + "&" + item.urlName.replace(/ /g, "-"), className: "slide-item" },
	    _react2.default.createElement(
	      "div",
	      { className: "slide-item__container" },
	      _react2.default.createElement(
	        "div",
	        { className: "slide-item__image-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "slide-item__image" },
	          _react2.default.createElement("img", { src: item.imgSrc, alt: item.productName })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "slide-item__content" },
	        _react2.default.createElement(
	          "h3",
	          { className: "slide-item__title" },
	          item.productName
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "slide-item__overlay" },
	          _react2.default.createElement(
	            "span",
	            { className: "slide-item__cta" },
	            "View Details"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = SlideItem;
	module.exports = exports["default"];

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(62);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Fixed import path
	
	var TESTIMONIALS_DATA = [{
	  id: 1,
	  text: "BMC Garam Masala is my go-to now. It's got that roasted-spice depth without the bitterness that ruins a lot of blends. Just a pinch at the end of cooking transforms my dal, paneer, or even bhindi into something richer. You can smell the difference.",
	  name: "Priya Deshpande",
	  age: 37,
	  location: "Pune, Maharashtra",
	  rating: 5
	}, {
	  id: 2,
	  text: "I've used a lot of spice blends over the years, but BMC Special Meat Masala stands out. The aroma alone tells you it's quality stuff. I use it for mutton curry, and people think I slow-roasted whole spices myself. It adds warmth without overdoing the heat.",
	  name: "Samiulla Rehman",
	  age: 44,
	  location: "Hyderabad, Telangana",
	  rating: 5
	}, {
	  id: 3,
	  text: "I picked up BMC Chana Masala on a trip to Mumbai, and it's now a regular in my kitchen. It gives chhole that real Delhi-style flavor — tangy, spicy, and bold without being harsh. Even my South Indian guests loved it with puris!",
	  name: "Lalita Iyer",
	  age: 58,
	  location: "Kochi, Kerala",
	  rating: 5
	}, {
	  id: 4,
	  text: "BMC Kitchen King Masala is a hidden gem. I sprinkle it into my mixed vegetables or paneer sabzi, and it just lifts the dish. It's got this rounded flavor — slightly sweet, slightly earthy — that makes simple meals taste restaurant-level.",
	  name: "Ravi Shankar",
	  age: 39,
	  location: "Mysuru, Karnataka",
	  rating: 5
	}, {
	  id: 5,
	  text: "Working with Bawa Masala Company for the last three years has helped us build a loyal customer base in our region. Their spice quality is consistent, and dispatch has never let us down.",
	  name: "Rajesh Mehta",
	  age: "Regional Distributor",
	  location: "Jaipur",
	  rating: 5
	}, {
	  id: 6,
	  text: "We've stocked BMC masalas for four years now. Customers ask for them by name, so restocking is quick, and the team is easy to reach if we ever need a rush order before a festival.",
	  name: "Sunita Agarwal",
	  age: "Wholesale Stockist",
	  location: "Ludhiana",
	  rating: 5
	}];
	
	var StarRating = function StarRating(_ref) {
	  var _ref$rating = _ref.rating,
	      rating = _ref$rating === undefined ? 5 : _ref$rating;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "testimonial__rating" },
	    [1, 2, 3, 4, 5].map(function (_, index) {
	      return _react2.default.createElement("img", { key: index, src: "/assets/staricon.png", alt: "Star Rating", className: "testimonial__star-icon" });
	    })
	  );
	};
	
	var TestimonialCard = function TestimonialCard(_ref2) {
	  var testimonial = _ref2.testimonial;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "testimonial__card" },
	    _react2.default.createElement(
	      "div",
	      { className: "testimonial__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "testimonial__quote" },
	        _react2.default.createElement(StarRating, { rating: testimonial.rating }),
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement("i", { className: "fa fa-quote-left", "aria-hidden": "true" })
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "testimonial__text" },
	        testimonial.text
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "testimonial__author" },
	        _react2.default.createElement(
	          "h4",
	          { className: "testimonial__name" },
	          testimonial.name,
	          ", ",
	          testimonial.age
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "testimonial__location" },
	          testimonial.location
	        )
	      )
	    )
	  );
	};
	
	var TESTIMONIALS_SLIDER_SETTINGS = {
	  dots: true,
	  infinite: true,
	  speed: 500,
	  autoplay: true,
	  autoplaySpeed: 4000,
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  arrows: true,
	  centerMode: false,
	  variableWidth: false, // Remove any custom transform settings that might interfere with slider movement
	  swipeToSlide: true,
	  focusOnSelect: false,
	  cssEase: "ease-out",
	  pauseOnHover: true,
	  adaptiveHeight: false,
	  responsive: [{
	    breakpoint: 1200,
	    settings: {
	      slidesToShow: 3,
	      slidesToScroll: 1
	    }
	  }, {
	    breakpoint: 992,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 1,
	      arrows: true,
	      dots: true
	    }
	  }, {
	    breakpoint: 768,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      arrows: false,
	      centerMode: true,
	      centerPadding: "40px",
	      dots: true
	    }
	  }, {
	    breakpoint: 480,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      arrows: false,
	      centerMode: true,
	      centerPadding: "20px",
	      dots: true
	    }
	  }]
	};
	
	var Testimonials = function (_React$Component) {
	  _inherits(Testimonials, _React$Component);
	
	  function Testimonials(props) {
	    _classCallCheck(this, Testimonials);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.loadReviewWidget = function () {
	      // Check if script is already loaded
	      if (document.querySelector('script[src="https://grwapi.net/widget.min.js"]')) {
	        return;
	      }
	
	      var script = document.createElement("script");
	      script.src = "https://grwapi.net/widget.min.js";
	      script.async = true;
	      script.onload = function () {
	        console.log("Review widget script loaded successfully");
	      };
	      script.onerror = function () {
	        console.error("Failed to load review widget script");
	      };
	      document.head.appendChild(script);
	    };
	
	    _this.handleSliderError = function (error) {
	      console.error("Slider error:", error);
	      _this.setState({ sliderError: true });
	    };
	
	    _this.renderGoogleReviews = function () {
	      return _react2.default.createElement(
	        "div",
	        { className: "testimonials__google-reviews" },
	        _react2.default.createElement(
	          "div",
	          { className: "reviews-container" },
	          _react2.default.createElement(
	            "div",
	            { className: "google-reviews-badge" },
	            _react2.default.createElement("div", { className: "review-widget_net", "data-uuid": "9f739938-cf88-46b6-b7d9-9f2f0baa8d4e", "data-template": "10", "data-lang": "en", "data-theme": "light" })
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      sliderError: false
	    };
	    return _this;
	  }
	
	  Testimonials.prototype.componentDidMount = function componentDidMount() {
	    this.loadReviewWidget();
	  };
	
	  Testimonials.prototype.render = function render() {
	    var sliderError = this.state.sliderError;
	
	
	    if (sliderError) {
	      // Fallback to grid layout if slider fails
	      return _react2.default.createElement(
	        "section",
	        { className: "testimonials" },
	        _react2.default.createElement(
	          "div",
	          { className: "testimonials__container" },
	          _react2.default.createElement(
	            "div",
	            { className: "testimonials__header" },
	            _react2.default.createElement(
	              "h2",
	              { className: "global__heading" },
	              "What Our Customers Say"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "testimonials__subtitle" },
	              "From home kitchens to regional distributors \u2014 BMC's quality and consistency earn trust across India."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "testimonials__grid" },
	            TESTIMONIALS_DATA.map(function (testimonial) {
	              return _react2.default.createElement(TestimonialCard, { key: testimonial.id, testimonial: testimonial });
	            })
	          ),
	          this.renderGoogleReviews()
	        )
	      );
	    }
	
	    try {
	      return _react2.default.createElement(
	        "section",
	        { className: "testimonials" },
	        _react2.default.createElement(
	          "div",
	          { className: "testimonials__container" },
	          _react2.default.createElement(
	            "div",
	            { className: "testimonials__header" },
	            _react2.default.createElement(
	              "h2",
	              { className: "global__heading" },
	              "What Our Customers Say"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "testimonials__subtitle" },
	              "From home kitchens to regional distributors \u2014 BMC's quality and consistency earn trust across India."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "testimonials__slider" },
	            _react2.default.createElement(
	              _reactSlick2.default,
	              TESTIMONIALS_SLIDER_SETTINGS,
	              TESTIMONIALS_DATA.map(function (testimonial) {
	                return _react2.default.createElement(
	                  "div",
	                  { key: testimonial.id, className: "testimonials__slide" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "testimonials__slide-inner" },
	                    _react2.default.createElement(TestimonialCard, { testimonial: testimonial })
	                  )
	                );
	              })
	            )
	          ),
	          this.renderGoogleReviews()
	        )
	      );
	    } catch (error) {
	      this.handleSliderError(error);
	      return null;
	    }
	  };
	
	  return Testimonials;
	}(_react2.default.Component);
	
	exports.default = Testimonials;
	module.exports = exports["default"];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HomeView = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(249);
	
	var _Heading = __webpack_require__(43);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _reactSlick = __webpack_require__(62);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(169);
	
	__webpack_require__(168);
	
	var _productListConstant = __webpack_require__(42);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(19);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(20);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _reactFacebookPixel = __webpack_require__(32);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _reactResponsive = __webpack_require__(98);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _SlideItem = __webpack_require__(203);
	
	var _SlideItem2 = _interopRequireDefault(_SlideItem);
	
	var _ProductCards = __webpack_require__(202);
	
	var _MarqueeText = __webpack_require__(198);
	
	var _MarqueeText2 = _interopRequireDefault(_MarqueeText);
	
	var _LegacyOfTaste = __webpack_require__(197);
	
	var _LegacyOfTaste2 = _interopRequireDefault(_LegacyOfTaste);
	
	var _Testimonials = __webpack_require__(204);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	__webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Constants
	var FACEBOOK_PIXEL_ID = "145006083100066";
	var TRANSITION_DURATION = 400;
	var AUTOPLAY_SPEED = 10000;
	
	// Image URLs
	var IMAGES = {
	  logo: "https://bawamasalacompany.com/assets/images/BMCHeaderLogo.png",
	  hero: {
	    desktop: ["https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop1.png", "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop2.png", "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop3.png", "https://bawamasalacompany.com/assets/images/hero/2026/hero-desktop4.png"],
	    mobile: ["https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile1.jpeg", "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile2.jpeg", "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile3.jpeg", "https://bawamasalacompany.com/assets/images/hero/2026/hero-mobile4.jpeg"]
	  },
	  buyNow: "https://bawamasalacompany.com/assets/images/Elements/Buy_Now_150x150.png"
	};
	
	// Slider configurations - ensure mobile and desktop have same settings
	var SLIDER_SETTINGS = {
	  hero: {
	    dots: true,
	    infinite: true,
	    speed: 500,
	    autoplay: true,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    autoplaySpeed: AUTOPLAY_SPEED,
	    centerMode: false,
	    adaptiveHeight: true,
	    arrows: true
	  },
	  products: {
	    desktop: {
	      dots: true,
	      infinite: true,
	      speed: 500,
	      arrows: true,
	      autoplay: false,
	      responsive: [{
	        breakpoint: 1200,
	        settings: {
	          slidesToShow: 3,
	          slidesToScroll: 3
	        }
	      }, {
	        breakpoint: 992,
	        settings: {
	          slidesToShow: 2,
	          slidesToScroll: 2
	        }
	      }, {
	        breakpoint: 768,
	        settings: {
	          slidesToShow: 2,
	          slidesToScroll: 2,
	          arrows: true,
	          dots: false
	        }
	      }]
	    },
	    mobile: {
	      dots: true,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      arrows: false
	    }
	  }
	};
	
	// Breakpoints
	var BREAKPOINTS = {
	  MOBILE: 768,
	  TABLET: 992,
	  DESKTOP: 1200
	};
	
	var HomeView = exports.HomeView = function (_React$Component) {
	  _inherits(HomeView, _React$Component);
	
	  function HomeView(props) {
	    _classCallCheck(this, HomeView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.initializeComponent = function () {
	      _this.updateWindowDimensions();
	      _this.setupEventListeners();
	      _this.initializeFacebookPixel();
	      _this.startTransition();
	    };
	
	    _this.setupEventListeners = function () {
	      window.addEventListener("resize", _this.updateWindowDimensions);
	    };
	
	    _this.initializeFacebookPixel = function () {
	      try {
	        _reactFacebookPixel2.default.init(FACEBOOK_PIXEL_ID);
	        _reactFacebookPixel2.default.track("ViewContent", _this.props.location);
	      } catch (error) {
	        console.warn("Facebook Pixel initialization failed:", error);
	      }
	    };
	
	    _this.startTransition = function () {
	      setTimeout(function () {
	        _this.setState({
	          defaultStyle: _this.getTransitionedStyle()
	        });
	      }, 500);
	    };
	
	    _this.cleanupComponent = function () {
	      window.removeEventListener("resize", _this.updateWindowDimensions);
	      _this.setState({
	        defaultStyle: _this.getExitStyle()
	      });
	    };
	
	    _this.getInitialStyle = function () {
	      return {
	        transition: "opacity " + TRANSITION_DURATION + "ms ease-in-out",
	        opacity: 0
	      };
	    };
	
	    _this.getTransitionedStyle = function () {
	      return {
	        transition: "opacity " + TRANSITION_DURATION + "ms ease-in-out",
	        opacity: 1
	      };
	    };
	
	    _this.getExitStyle = function () {
	      return {
	        transition: "opacity " + TRANSITION_DURATION + "ms ease-in-out",
	        opacity: 0.1
	      };
	    };
	
	    _this.getInitialSlidesToShow = function () {
	      if (typeof window === "undefined") return 4;
	      return _this.calculateSlidesToShow(window.innerWidth);
	    };
	
	    _this.calculateSlidesToShow = function (width) {
	      if (width <= BREAKPOINTS.MOBILE) return 1;
	      if (width <= BREAKPOINTS.TABLET) return 2;
	      if (width <= BREAKPOINTS.DESKTOP) return 3;
	      return 4;
	    };
	
	    _this.updateWindowDimensions = function () {
	      var newSlidesToShow = _this.calculateSlidesToShow(window.innerWidth);
	
	      if (_this.state.slidesToShow !== newSlidesToShow) {
	        _this.setState({ slidesToShow: newSlidesToShow });
	      }
	    };
	
	    _this.renderHeroSlider = function (images, altPrefix) {
	      return _react2.default.createElement(
	        _reactSlick2.default,
	        SLIDER_SETTINGS.hero,
	        images.map(function (img, index) {
	          return _react2.default.createElement(
	            "div",
	            { key: index, className: "slider-slide", style: { width: "100%" } },
	            _react2.default.createElement(
	              "div",
	              { className: "home__slider" },
	              _react2.default.createElement("img", {
	                src: img,
	                alt: altPrefix + " banner image " + (index + 1),
	                className: "hero-image",
	                loading: index === 0 ? "eager" : "lazy",
	                style: {
	                  display: "block",
	                  width: "100%",
	                  height: "auto",
	                  objectFit: "contain",
	                  objectPosition: "center"
	                }
	              })
	            )
	          );
	        })
	      );
	    };
	
	    _this.renderDesktopHero = function () {
	      return _react2.default.createElement(
	        _reactResponsive2.default,
	        { query: "(min-width: 769px)" },
	        _react2.default.createElement(
	          "div",
	          { className: "home__copy__slider" },
	          _react2.default.createElement(
	            "div",
	            { className: "slider__content" },
	            _this.renderHeroSlider(IMAGES.hero.desktop, "BMC desktop")
	          )
	        )
	      );
	    };
	
	    _this.renderMobileHero = function () {
	      return _react2.default.createElement(
	        _reactResponsive2.default,
	        { query: "(max-width: 768px)" },
	        _react2.default.createElement(
	          "div",
	          { className: "home__copy__slider" },
	          _react2.default.createElement(
	            "div",
	            { className: "slider__content" },
	            _this.renderHeroSlider(IMAGES.hero.mobile, "BMC mobile")
	          )
	        )
	      );
	    };
	
	    _this.renderProductsSection = function () {
	      return _react2.default.createElement(
	        "div",
	        { className: "home__about" },
	        _react2.default.createElement(_Heading2.default, { title: "Bestselling Spices" }),
	        _react2.default.createElement(
	          "div",
	          { className: "home__about__text" },
	          "BMC Masalas offer a vast range of variety, tickling the taste buds of every food lover; whole spices, organic spices, spice mixes, spice blends and powders with exquisite aroma, texture and taste, in the Classic sizes, as well as new Mini Packs that make for ease, convenience and quick addition to flavour, taste and heat in all that is cooking!"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "buynow__logo" },
	          _react2.default.createElement("img", { src: IMAGES.buyNow, alt: "Buy Now", className: "" })
	        ),
	        _react2.default.createElement(_ProductCards.ProductCardsContainer, { maxItems: 24 })
	      );
	    };
	
	    _this.state = {
	      slidesToShow: _this.getInitialSlidesToShow(),
	      defaultStyle: _this.getInitialStyle()
	    };
	    return _this;
	  }
	
	  HomeView.prototype.componentDidMount = function componentDidMount() {
	    this.initializeComponent();
	  };
	
	  HomeView.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cleanupComponent();
	  };
	
	  // Initialization methods
	
	
	  // Cleanup methods
	
	
	  // Style methods
	
	
	  // Window dimension methods
	
	
	  // Render methods
	
	
	  // Use identical rendering method for both desktop and mobile
	
	
	  HomeView.prototype.render = function render() {
	    var defaultStyle = this.state.defaultStyle;
	    var location = this.props.location;
	
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Bawa Masala Company Estd. 1952 | India's Finest Spices & Spice Blends",
	        description: "Bawa Masala Company (BMC), established 1952, brings premium quality Indian spices and masala blends to kitchens and dealers nationwide.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "global__wrapper", style: { background: "#e9eef6", margin: 0, padding: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "home__wrapper", style: _extends({}, defaultStyle, { margin: 0, padding: 0 }) },
	          _react2.default.createElement(_MarqueeText2.default, null),
	          this.renderDesktopHero(),
	          this.renderMobileHero(),
	          _react2.default.createElement(_LegacyOfTaste2.default, null),
	          this.renderProductsSection(),
	          _react2.default.createElement(_Testimonials2.default, null),
	          _react2.default.createElement("div", { className: "product__conveyor" })
	        )
	      )
	    );
	  };
	
	  return HomeView;
	}(_react2.default.Component);
	
	exports.default = HomeView;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _home = __webpack_require__(207);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _home2.default;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-6bb9c2e5cfa90615852f.js